export default __webpack_public_path__ + "static/media/andrea--mobile.5547d5a2.jpg";